<template>
  <div>
    <!-- pc端 -->
    <div class="num">
      <div class="num-left">
        <i
          class="collapse-btn"
          :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          :title="isCollapse ? '展开导航' : '折叠导航'"
          @click="toggleCollapse"
        ></i>
        <div class="num1" :style="$i18n.locale === 'en' ? '' : 'letter-spacing: 20px'">{{(this.project_title)}}</div>
      </div>
        <div class="num2">
            <span>{{$t('header.用户名')}}：{{this.username}}</span>
            <div v-if="enableDashboard" @click="VisualizationDashboard" style="cursor: pointer; margin-right: 20px;">可视化大屏</div>
            <el-dropdown>
    <el-badge is-dot class="item" v-show="yesi">{{$t('header.公告')}}</el-badge>
    <el-badge class="item" v-show="muio">{{$t('header.公告')}}</el-badge>
  <el-dropdown-menu slot="dropdown">
    <el-table
    :data="tableData"
    style="width: 100%"
    max-height="250">
    <el-table-column
      fixed
      prop="message"
      :label="$t('header.公告')"
      width="350">
    </el-table-column>
    <el-table-column
      fixed
      prop="create_time"
      :label="$t('header.发布时间')"
      width="200">
    </el-table-column>
  </el-table>
  </el-dropdown-menu>
</el-dropdown>
            <div class="tcui">
              <span @click="tuichu">{{$t('header.退出')}}</span>
            </div>
        </div>
    </div>
    <!-- 移动端 -->
    <div class="move">
      <div class="text">{{$t('project.title')}}</div>
      <div class="VVEE">
      <div class="icons">
        <el-button type="info" icon="el-icon-s-operation" v-show="xinas" @click="xianshi"/>
        <el-button type="info" icon="el-icon-close" v-show="quxnas" @click="quxiao"/>
      </div>
      <div class="tuidt">
        <!-- <img src="@/components/container/img/igm2.png" alt="" @click="tuichu"> -->
        <el-dropdown trigger="click" @command="handleClick">
      <span class="el-dropdown-link">
        <img :src='`https://btmswaterbg.sdbina.com/api/v1/projectLogo?token=${token}`' alt="">
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="dengchu">{{$t('header.退出')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
      </div>
    </div>
    </div>
    <!-- 移动端》》导航菜单 -->
    <div class="menu" v-show="daohen">
      <el-menu
  :default-active="activePath"
  class="el-menu-demo"
  router
  @select="handleSelect"
  background-color="#545c64"
  text-color="#fff"
  active-text-color="#ffd04b">
  <el-menu-item :index="item.path" v-for="item in noChildren"
        :key="item.id" @click="saveNavState('/' + item.path)">
        <template>
          <span slot="title" style="font-size: 1rem;">{{(item.authName)}}</span>
        <!-- <i class="iconfont icon-dian" style="margin-left: 0px" v-show="icons"></i> -->
        </template>
      </el-menu-item>
        <el-submenu :index="'/' + item.path" v-for=" item in hasChilren "
         :key="item.id">
            <template slot="title">
              <span style="font-size: 1rem;">{{( item.authName)}}</span>
              <!-- <i class="iconfont icon-dian" style="margin-left: 40px" v-show="icons"></i> -->
            </template>
          <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.childern"
            :key="subItem.id" @click="saveNavState('/' + item.path)">
              <template>
                <!-- 图表 -->
                <i class=""></i>
                <!-- 文本 -->
                <span style="letter-spacing: 1px;">{{( subItem.authName)}}</span>
                <!-- <i class="iconfont icon-dian" style="margin-left: 40px" v-show="icons"></i> -->
              </template>
            </el-menu-item>
          </el-submenu>
</el-menu>
  </div>
  </div>
</template>
<script>
import { DEFAULT_MENU_LIST, mergeMenuConfig } from '@/utils/menuConfig'

export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      yesi: true,
      muio: false,
      // 移动端
      xinas: true,
      quxnas: false,
      daohen: false,
      activePath: '',
      // 与 PC 侧栏共用菜单配置，支持自定义名称
      menulist: JSON.parse(JSON.stringify(DEFAULT_MENU_LIST)),
      // pc端
      username: null,
      project_title: null,
      fasinull: {
        id: null,
        is_admin: null,
        project_id: null,
        project_name: null,
        token: null,
        username: null
      },
      buosDasi: {
        token: null
      },
      noties: {
        token: null
      },
      token: null,
      tableData: []
    }
  },
  created () {
    this.token = this.$store.state.print.goodsForeNo.token
    this.username = this.$store.state.print.goodsForeNo.username
    this.project_title = this.$store.state.print.goodsForeNo.project_title
    // 移动端：优先用 store 中已保存的菜单配置，再拉取最新
    if (this.$store.state.print.menuConfig && this.$store.state.print.menuConfig.length) {
      this.menulist = mergeMenuConfig(this.$store.state.print.menuConfig)
    }
    this.fetchMenuConfig()
    // 移动
    this.setCurrentRoute()
    this.activePath = window.sessionStorage.getItem('activePath')
    this.Xiaoxin()
    // 获取本地存储的语言设置，如果有的话
  },
  // 移动
  watch: {
    $route () {
      this.setCurrentRoute()
    },
    '$store.state.print.menuConfig': {
      handler (val) {
        if (val && val.length) {
          this.menulist = mergeMenuConfig(val)
        }
      },
      deep: true
    }
  },
  // 移动
  computed: {
    noChildren () {
      return this.menulist.filter((item) => !item.childern)
    },
    hasChilren () {
      return this.menulist.filter((item) => item.childern)
    },
    // 判断是否显示可视化大屏
    enableDashboard () {
      const goodsForeNo = this.$store.state.print?.goodsForeNo
      return goodsForeNo?.enable_dashboard === true
    }
  },
  methods: {
    // 获取菜单配置（与 PC 侧栏一致，使自定义名称在手机端生效）
    fetchMenuConfig () {
      const params = { token: this.token }
      this.$api.lonig.getMenuConfig(params).then(res => {
        if (res && res.data && res.data.status === 'success' && res.data.data) {
          const config = mergeMenuConfig(res.data.data)
          if (config && config.length) {
            this.menulist = config
            this.$store.commit('print/STORE_MENU_CONFIG', config)
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error('获取菜单配置失败', err)
      })
    },
    toggleCollapse () {
      this.$emit('toggle-collapse')
    },
    // 可视化大屏
    VisualizationDashboard () {
      this.$router.push('/VisualizationDashboard')
    },
    handleClick (command) {
      if (command === 'dengchu') {
        this.buosDasi.token = this.$store.state.print.goodsForeNo.token
        this.$api.lonig.postwebUserLogout(this.buosDasi).then((res) => {
          if (res.data.status === 'success') {
            this.$router.push('/', this.fasinull)
            this.$notify({
              title: this.$t('message.成功'),
              message: res.data.message,
              type: 'success'
            })
            window.sessionStorage.clear()
            console.log(window.sessionStorage, 'window.sessionStorage')
            var stotag = this.$store.state.print.goodsForeNo.token
            stotag.clear()
          } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        })
      }
    },
    // PC端
    deleteRow (index, rows) {
      rows.splice(index, 1)
    },
    tuichu () {
      this.buosDasi.token = this.$store.state.print.goodsForeNo.token
      this.$api.lonig.postwebUserLogout(this.buosDasi).then((res) => {
        console.log(res, '退出')
        if (res.data.status === 'success') {
          this.$router.push('/', this.fasinull)
          this.$notify({
            title: this.$t('message.成功'),
            message: res.data.message,
            type: 'success'
          })
          window.sessionStorage.clear()
          console.log(window.sessionStorage, 'window.sessionStorage')
          var stotag = this.$store.state.print.goodsForeNo.token
          stotag.clear()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
    },
    Xiaoxin () {
      this.noties.token = this.$store.state.print.goodsForeNo.token
      this.$api.lonig.notifys(this.noties).then((res) => {
        console.log(res, '消息')
        if (res.data.status === 'success') {
          this.tableData = res.data.data
          if (res.data.total === 0) {
            this.muio = true
            this.yesi = false
          }
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
    },
    // 移动端
    // 保存链接的激活状态.。。》移动
    saveNavState (activePath) {
      console.log('dwdhwdh')
      this.daohen = false
      this.quxnas = false
      this.xinas = true
      this.show = !this.show
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    setCurrentRoute () {
      this.defaultActive = this.$route.name
    },
    xianshi () {
      this.quxnas = true
      this.xinas = false
      this.daohen = true
    },
    quxiao () {
      this.xinas = true
      this.quxnas = false
      this.daohen = false
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>
<style lang="less" scoped>
.num{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    .num-left{
        display: flex;
        align-items: center;
        min-width: 0;
    }
    .collapse-btn{
        font-size: 22px;
        color: #606266;
        cursor: pointer;
        margin-right: 16px;
        flex-shrink: 0;
        transition: color 0.2s ease;
        &:hover{
            color: #1890ff;
        }
    }
    .num1{
        margin-left: 0;
        color: #7d7d7d;
        font-size: 2rem;
        // line-height: 90px;
        font-family: MicrosoftYaHeiUI-Bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .language-switch {
        margin-right: 20px;
        display: flex;
        align-items: center;
    }
    .num2{
        position: relative;
        .yuo{
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #7047FD;
            position: absolute;
            top: 28px;
            left: 110px;
        }
        display: flex;
        align-items: center;
        font-size: 14px;
        span{
            margin-right: 32px;
        }
        img{
            width: 32px;
            height: 32px;
            margin-right: 32px;
        }
    }
}
.move{
height: 60px;
  padding: 0px 20px;
  color: #fff;
  background-color: #545C64;
  display: flex;
  justify-content: space-between;
   .VVEE{
      display: flex;
      .tuidt{
        // border: 1px solid;
        // height: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          padding-top: 15px;
          margin-left: 10px;
          width: 50px;
          height: 40px;
        }
      }
    }
}
.menu{
  position: absolute;
  z-index: 999999;
  border-top: 1px solid #fff;
  background-color: #7047FD;
  .el-menu{
  background-color: #545C64;
 ::v-deep .el-submenu__icon-arrow{
    right: 10px;
  }
  }
}
// 消息
.el-dropdown{
  width: 60px;
  height: 20%;
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.tcui{
margin-left: 20px;
  cursor:pointer;/*鼠标变小手*/
}
.el-badge{
  height: 100%;
  display: flex;
  align-items: center;
  cursor:pointer;/*鼠标变小手*/
}
// pc端
@media (min-width: 768px) {
  .move{
    display: none;
  }
  .menu{
    display: none;
  }
}
// 移动
@media (max-width: 768px) {
     
  .num{
    display: none;
  }
}
</style>
